import React,{ useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Col, Row } from 'antd';

import BaseBanner from '../../components/BaseBanner/BaseBanner'
import Menu from '../../components/Menu/Menu'
import CardDom from '../../components/CardDom/CardDom';
import Community from '../../components/Community/Community';
import CarouselDom from '../../components/CarouselDom/CarouselDom';
import BigCard from '../../components/BigCard/BigCard';
import Contrast from '../../components/Contrast/Contrast';

import { getProductList } from '../../api/goods'

import './shop.less'

const Shop = () =>{
  const {state} = useLocation();
  const navigate = useNavigate();
  const [width, setWidth] = useState(window.innerWidth);

  const [selectMenu, setSelectMenu] = useState('')
  const menuData = [
    {label: '全部商品',value: '0'},
    {label: '补充剂',value: '1'},
  ]


  const banner = [{
    name: '全部商品',
    key: '全部商品',
    img: require('../../image/banner3-3840x960.jpg'),
  },{
    name: '补充剂',
    key: '补充剂',
    img: require('../../image/banner2-3840x960.jpg'),
  },{
    name: 'Samples',
    key: 'Samples',
    img: require('../../image/banner1-3840x960.png'),
  },{
    name: 'Bundles',
    key: 'Bundles',
    img: require('../../image/banner1-3840x960.png'),
  }]

  
  let [goodsList, setGoodsList] = useState([])
  let goodsCarouselData = {
    CarouselText: '还不确定？试试我们的方案',
    btnText: '店铺样品',
    link: '/shop'
  }
  
  let communityData = {
    cardList: [{
      type: 'card',
      star: 5,
      title: 'I feel like I have gotten younger',
      content: `I simply feel like I have more energy to do everything.  This is like a caffeine jolt without any of the side effects.  I am hoping these results continue and build on what is currently happening?  I'm willing to continue for a couple of months to find out.`,
      name: 'Kathryn C',
      productImg: require('../../image/shop1-1200x1200.avif'),
      productName: 'Mitopure Softgels',
      link: '',
    },{
      type: 'card',
      star: 5,
      title: 'Great Addition to Skincare Routine!',
      content: `The night cream has been a great addition to my skincare routine.  I feel it has lightened my dark spots and made my skin less dull.  It feels indulgent but is still an affordable addition to my lotions and potions!`,
      name: 'Jolene M',
      productImg: require('../../image/shop4-1200x1200.avif'),
      productName: 'The Night Cream',
      link: '',
    },{
      type: 'card',
      star: 5,
      title: 'Actually works!',
      content: `I grabbed the Time-Line Day Cream for my wife due to some uneven skin tone she was going through after having our daughter a year ago. She started a month ago, and we definitely saw the change! My wife's skin tone became smoother and clearer. Many of the blemishes and uneven skin tone had disappeared. This product is amazing!`,
      name: 'Nadim H',
      productImg: require('../../image/shop2-1200x1200.avif'),
      productName: 'The Day Cream',
      link: '',
    },{
      type: 'card',
      star: 5,
      title: 'Wonderful',
      content: `This serum truly makes you look younger and feel confident. I felt like my wrinkles were fading and my skin felt tighter after just one week. I also look brighter and moisturized ! I recommend this serum to anyone looking for a little help looking bright and youthful!`,
      name: 'Marleise C',
      productImg: require('../../image/shop5-1200x1200.avif'),
      productName: 'The Serum',
      link: '',
    }],
    videoList: [{
      type: 'video',
      cardType: 'doctor',

      img: require("../../image/community-img.png"),
      video: "",
      name: 'Dr. Mark Hyman, MD',
      achievement: 'Functional Medicine Physician, 15x New York Times Bestselling Author'
    },{
      type: 'video',
      cardType: 'doctor',

      img: require("../../image/community-img.png"),
      video: "",
      name: 'Dr. Gabrielle Lyon',
      achievement: 'Founder Institute for Muscle-Centric Medicine®'
    },{
      type: 'video',
      cardType: 'userComment',

      img: require("../../image/community-img.png"),
      video: "",
      name: 'idodeclaire2013',
      productImg: require('../../image/shop1-1200x1200.avif'),
      productName: 'Mitopure Softgels',
    },{
      type: 'video',
      cardType: 'userComment',

      img: require("../../image/community-img.png"),
      video: "",
      name: 'chrisellelim',
      productImg: require('../../image/shop5-1200x1200.avif'),
      productName: 'The Serum',
    }]
  }

  let bigCardData = {
    type: 'bgCard',
    bgImg: require('../../image/bigCardBg-3840x1440.png'),
    textWidth: '30%',
    textPosition: 'right',
    title: '线粒体能量工厂',
    description: '通过激活线粒体功能，改善口腔与肺部细胞代谢，有效预防和缓解牙周炎、肺纤维化、口腔溃疡等健康问题，为呼吸健康筑起屏障。',
    btnConfig:{
      text: '了解更多',
      link: '/science'
    }
  }

  // recommend_goods
  let [bigGoods, setBigGoods] = useState({})

  useEffect(()=>{
    if(state && state?.menu){
      console.log(menuData.find(e=> e.label === state.menu))
      setSelectMenu(menuData.find(e=> e.label === state.menu))
    }else{
      setSelectMenu(menuData[0])
    }
  },[state])

  const getProductListFn = async () =>{
    let update = {
      page: 1,
      limit: 100,
      prodType: selectMenu.value,
      prodStatus: '1',
    }
    let res = await getProductList(update)
    // console.log(res)
    if(res?.msg === 'success'){
      let data = res?.data.map((e,i)=>{
        if(i===0){
          let newBigGoods = {
            type: 'bigGoods',
            content:{
              title: e.prodName,
              description: e.description,
              img: e.prodImg1,
              // star: 4.4,
              // commentCount: 2813,
              bestseller: false,
              tag: false
            },
            btnConfig:{
              link:`/shopDetail?id=${e.id}`,
            }
          }
          console.log(newBigGoods)
          setBigGoods(()=> newBigGoods)
        }
        
        return ({
          type: 'goods',
          content:{
            title: e.prodName,
            description: e.description,
            img: e.prodImg1,
            imgHover: e.prodImg2,
            // star: 4.4,
            // commentCount: 2813,
            bestseller: false,
            tag: false
          },
          btnConfig:{
            link:`/shopDetail?id=${e.id}`,
          }
        })
      })
      console.log(res?.data)
      setGoodsList(()=> data)
    }
  }

  useEffect(()=>{
    if(selectMenu.value){
      getProductListFn()
    }
  },[selectMenu])

  useEffect(()=>{
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
 
    // 添加事件监听器
    window.addEventListener('resize', handleResize);
 
    // 清理函数，组件卸载时移除事件监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  },[])

  return (
    <div style={{overflow: 'hidden'}}>
      <BaseBanner banner={banner.find((e)=> e.key === selectMenu.label)}/>

      {/* 菜单 */}
      <Menu menuData={menuData} selectMenu={selectMenu} setSelectMenu={setSelectMenu}/>

      {/* 商品列表 */}
      <div style={{width: '100%', padding: 20,display:'flex',justifyContent: 'center'}}>
        <Row className="shop-box" gutter={[16, 16]}>
          {goodsList.map((e,i)=>{
            return (
              <Col span={width>770? 8:24} key={i} className="Carousel-item-box" style={{paddingBottom: 60}}>
                <div className="Carousel-item" style={{textAlign:'left'}}>
                  <CardDom type={e.type} content={e.content} btnConfig={e.btnConfig}/>
                </div>
              </Col>
            )
          })}
        </Row>
      </div>

      {/* 对比-营养 */}
      {/* <Contrast type={'nutrition'}/> */}
      {/* 对比-质量 */}
      {/* <Contrast type={'quality'}/> */}
      
      {/* 推荐商品 */}
      {/* <CardDom type={bigGoods.type} content={bigGoods.content} btnConfig={bigGoods.btnConfig}/> */}
      
      {/* 社区 */}
      {/* <div>
        <Community communityData={communityData}/>
      </div> */}

      {/* <BigCard bigCardData={bigCardData}/> */}

      {/* 商品轮播 */}
      {/* <CarouselDom CarouselData={{data:goodsList, ...goodsCarouselData}}/> */}

    </div>
  )
}

export default Shop